import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-college-dialog-box',
  templateUrl: './college-dialog-box.component.html',
  styleUrls: ['./college-dialog-box.component.scss']
})
export class CollegeDialogBoxComponent implements OnInit {
  CollegeDataForm: FormGroup;
  isReadonlyDelete = false;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  isReadonly = false;
  TownVisible = false;
  districtSelect = true;
  CgTypeBoolean = false;
  typelist: any;
  filteredListTypeList: any;
  dynamicrecords: any;
  DsCodelist: any;
  filteredListDistCode: any;
  tncodelist: any;
  filteredListTownCode: any;
  ColgCreate = true;
  ColgUpdate = true;
  ColgDelete = true;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  APIService: string;
  userPermission: any;
  utp: string;
  Towns: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    public dialogRef2: MatDialogRef<CollegeDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'College' && element.PCreate == false) {
          this.ColgCreate = false;
        }
        if (element.PageName == 'College' && element.PUpdate == false) {
          this.ColgUpdate = false;
        }
        if (element.PageName == 'College' && element.PDelete == false) {
          this.ColgDelete = false;
        }
      });
    }

    this.loadFormFieldConditions();
    window.scroll(0, 0);
    let CgS1Cent = true;
    this.TownVisible = false;
    this.districtSelect = true;
    this.CollegeDataForm = this.fb.group({
      CgCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$'), Validators.maxLength(5),]),
      CgShName: new FormControl('', [Validators.required]),
      CgName: new FormControl('', [Validators.required]),
      CgAddr1: new FormControl('', [Validators.required]),
      CgAddr2: new FormControl('', [Validators.required]),
      CgAddr3: new FormControl(''),
      CgPin: new FormControl('', [Validators.required, Validators.pattern('^[1-9]{1}?[0-9]*$'), Validators.maxLength(6), Validators.minLength(6)]),
      CgTnCode: new FormControl(''),
      DsCode: new FormControl('', Validators.required), //add dummy
      CgLoca: new FormControl(''),
      CgS1Cent: new FormControl(CgS1Cent),
      CgS2Cent: new FormControl(''),
      CgS1Capa: new FormControl(''),
      CgS2Capa: new FormControl(''),
      CgOnlyCent: new FormControl(''),
      CgType: new FormControl(''),
      // removed for kle for now 
      CgEmail: new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), Validators.maxLength(50)]),
      CgWeb: new FormControl('', [Validators.pattern("^(?!-)[a-zA-Z0-9-]{1,63}(?<!-)(\.[a-zA-Z]{2,})+$"), Validators.maxLength(50)]),
      CgPhone: new FormControl('', [Validators.required, Validators.pattern('^[0-9-+ &\\s]*$'), Validators.minLength(10), Validators.maxLength(12)]),
      CgFax: new FormControl('', [Validators.pattern('^[0-9-+ .&\\s]*$'), Validators.minLength(9), Validators.maxLength(12)]),

    });
    if (sessionStorage.getItem('Inst') == '6') {
      this.CgTypeBoolean = false;
    } else {
      this.CgTypeBoolean = true;
    };

    // load all the api at once 
    this.fetchSecretData();
    
    this.fetchDistrict();
    this.fetchtype();
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.DeletePrepopulation(this.data.selected);
    } 
    // load all the api at once 
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.Towns = res.projectPharam['Towns'];
        if(res.projectPharam['Towns'] == 'Y'){
          this.TownVisible = true;
          
        }
        else if(res.projectPharam['Towns'] == 'N'){
          this.TownVisible = false;
        }
      }
      else{
        this.spinner.hide()
      }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }

  SelectTn(dsCode){
    this.spinner.show()
    const payload = {};
    payload['TnDsCode'] = dsCode;
    this.umsService.getTown(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.districtSelect = false
        this.tncodelist = res.data;
        this.filteredListTownCode = this.tncodelist.slice();
      }
      else{
        this.spinner.hide()
        this.districtSelect = true;
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  // Submit records Start 
  submit() {
    if (this.CollegeDataForm.invalid) {
      this.CollegeDataForm.get('CgCode').markAsTouched();
      this.CollegeDataForm.get('CgShName').markAsTouched();
      this.CollegeDataForm.get('CgName').markAsTouched();
      this.CollegeDataForm.get('CgAddr1').markAsTouched();
      this.CollegeDataForm.get('CgAddr2').markAsTouched();
      this.CollegeDataForm.get('CgAddr3').markAsTouched();
      this.CollegeDataForm.get('CgPin').markAsTouched();
      this.CollegeDataForm.get('DsCode').markAsTouched();
      this.CollegeDataForm.get('CgType').markAsTouched();
      this.CollegeDataForm.get('CgEmail').markAsTouched();
      this.CollegeDataForm.get('CgWeb').markAsTouched();
      this.CollegeDataForm.get('CgPhone').markAsTouched();
      this.CollegeDataForm.get('CgFax').markAsTouched();
      if (this.districtSelect == true) {
        // Clear validators
        const control = this.CollegeDataForm.get('CgTnCode');
        control.clearValidators();
        control.updateValueAndValidity(); // Trigger update
      } else if (this.districtSelect == false) {
        // Set validators
        const control = this.CollegeDataForm.get('CgTnCode');
        control.setValidators([Validators.required]);
        control.updateValueAndValidity(); // Trigger update
        control.markAsTouched();
      }
      return;
    } else {
      this.createCollege();
    }
  }

  createCollege() {
    this.submitpayload = this.CollegeDataForm.value;
    if(this.Towns == 'Y'){
      this.submitpayload['CgTnCode'] = this.submitpayload['CgTnCode'];
      this.submitpayload['DsCode'] = this.submitpayload['DsCode'];
    }
    else if(this.Towns == 'N'){
      this.submitpayload['CgTnCode'] = this.submitpayload['DsCode'];
    }
    this.spinner.show();
    // if (this.submitpayload['CgOnlyCent'] == "") {
    //   this.submitpayload['CgS1Cent'] = true;
    // }
    // else if (this.submitpayload['CgOnlyCent'] == true) {
    //   this.submitpayload['CgS1Cent'] = false;
    // }
    this.umsService.addCollege(this.submitpayload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          const data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.dialogRef2.close();
          });
        } else {
          this.spinner.hide();
          const data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef2.close();
          });
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        // this.dialogRef.afterClosed().subscribe((result) => {
        //   this.dialogRef2.close();
        // });
      }
    );
  }
  // Submit Records End
  // Update Record Start
  update() {
    this.submitpayload = this.CollegeDataForm.value;
    if (this.CollegeDataForm.invalid) {
      this.CollegeDataForm.get('CgCode').markAsTouched();
      this.CollegeDataForm.get('CgShName').markAsTouched();
      this.CollegeDataForm.get('CgName').markAsTouched();
      this.CollegeDataForm.get('CgAddr1').markAsTouched();
      this.CollegeDataForm.get('CgAddr2').markAsTouched();
      this.CollegeDataForm.get('CgAddr3').markAsTouched();
      this.CollegeDataForm.get('CgPin').markAsTouched();
      this.CollegeDataForm.get('DsCode').markAsTouched();
      this.CollegeDataForm.get('CgType').markAsTouched();
      this.CollegeDataForm.get('CgEmail').markAsTouched();
      this.CollegeDataForm.get('CgWeb').markAsTouched();
      this.CollegeDataForm.get('CgPhone').markAsTouched();
      this.CollegeDataForm.get('CgFax').markAsTouched();
      this.CollegeDataForm.get('CgOnlyCent').markAsTouched();
      this.CollegeDataForm.get('CgS1Cent').markAsTouched();
      if (this.districtSelect == true) {
        // Clear validators
        const control = this.CollegeDataForm.get('CgTnCode');
        control.clearValidators();
        control.updateValueAndValidity(); // Trigger update
      } else if (this.districtSelect == false) {
        // Set validators
        const control = this.CollegeDataForm.get('CgTnCode');
        control.setValidators([Validators.required]);
        control.updateValueAndValidity(); // Trigger update
        control.markAsTouched();
      }
      return;
    }
    else {
      this.updateCollegeData();
    }
  }
  updateCollegeData() {
    this.spinner.show();
    this.submitpayload = this.CollegeDataForm.value;
    
    // if (this.submitpayload['CgOnlyCent'] == "") {
    //   this.submitpayload['CgS1Cent'] = true;
    // }
    // else if (this.submitpayload['CgOnlyCent'] == true) {
    //   this.submitpayload['CgS1Cent'] = false;
    // }
    this.umsService.updateCollege(this.submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          const data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';

          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data,
          );
        } else {
          const data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }
  prepopulation(id) {
    
    const payload = {};
    payload['CgCode'] = id.CgCode;
    payload['CgName'] = id.CgName;
    payload['DsCode'] = id.DsCode;
    payload['TnCode'] = id.TnCode;
    payload['CgCent'] = id.CgCent;
    payload['CgOnlyCent'] = id.CgOnlyCent;
    payload['CgType'] = id.CgType;
    this.isReadonly = true;
    this.umsService.getCollege(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        let CgS1Cent = false;
        let CgOnlyCent = false;
        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        if (data.CgS1Cent == 1) {
          CgS1Cent = true;
        } else {
          CgS1Cent = false;
        }
        if (data.CgOnlyCent == 1) {
          CgOnlyCent = true;
        } else {
          CgOnlyCent = false;
        }
        this.SelectTn(data.DsCode)
        this.CollegeDataForm = this.fb.group({
          CgCode: new FormControl(data.CgCode, [
            Validators.required,
            Validators.pattern('^[a-zA-z0-9-&]*$'),
            Validators.maxLength(5),
          ]),
          CgShName: new FormControl(data.CgShName, [
            Validators.required
          ]),
          CgName: new FormControl(data.CgName, [
            Validators.required
          ]),
          CgAddr1: new FormControl(data.CgAddr1, [Validators.required]),
          CgAddr2: new FormControl(data.CgAddr2, [Validators.required]),
          CgAddr3: new FormControl(data.CgAddr3),
          CgLoca: new FormControl(''),
          CgPin: new FormControl(data.CgPin, [Validators.required, Validators.pattern('^[1-9]{1}?[0-9]*$'), Validators.maxLength(6), Validators.minLength(6)]),
          CgTnCode: new FormControl(data.TnCode),
          DsCode: new FormControl(data.DsCode, Validators.required), //add dummy
          CgS1Cent: new FormControl(CgS1Cent),
          CgS2Cent: new FormControl(''),
          CgS1Capa: new FormControl(''),
          CgS2Capa: new FormControl(''),
          CgOnlyCent: new FormControl(CgOnlyCent),
          CgType: new FormControl(data.CgType),
          // removed form kle
          CgEmail: new FormControl(data.CgEmail, [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), Validators.maxLength(50)]),
          CgWeb: new FormControl(data.CgWeb, [Validators.pattern("^(?!-)[a-zA-Z0-9-]{1,63}(?<!-)(\.[a-zA-Z]{2,})+$"), Validators.maxLength(50)]),
          CgPhone: new FormControl(data.CgPhone, [Validators.required, Validators.pattern('^[0-9-+ &\\s]*$'), Validators.minLength(10)]),
          CgFax: new FormControl(data.CgFax, [Validators.pattern('^[0-9-+ .&\\s]*$'), Validators.minLength(9)]),

        });
      } else {
        this.umsService.openSnackbar(res.message);
      }
    });
  }
  // Update Record End
  // delete record start 
  openConformationModalBox() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deletedata(this.CollegeDataForm.value);
        this.dialogRef2.close();
      }
      else {
        this.dialogRef2.close();
      }
    });
  }
  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        CgCode: id.CgCode,
        CgName: id.CgName,
        CgShName: id.CgShName,
        CgAddr1: id.CgAddr1,
        CgAddr2: id.CgAddr2,
        CgAddr3: id.CgAddr3,
        CgLoca: id.CgLoca,
        CgPin: id.CgPin,
        CgTnCode: id.CgTnCode,
        CgS1Cent: id.CgS1Cent,
        CgS2Cent: id.CgS2Cent,
        CgS1Capa: id.CgS1Capa,
        CgS2Capa: id.CgS2Capa,
        CgOnlyCent: id.CgOnlyCent,
        CgType: id.CgType,
        CgEmail: id.CgEmail,
        CgWeb: id.CgWeb,
        CgPhone: id.CgPhone,
        CgFax: id.CgFax,
        DsName: id.DsName,
        TnName: id.TnName,
        DsCode: id.DsCode,
        TnCode: id.TnCode,
      },
    };
    this.httpClient
      .delete(this.APIService + '/masters/collage', options)
      .subscribe((s) => {
        this.spinner.hide();
        const cc = [];
        cc.push(s);
        const data = {};
        data['message'] = cc[0].message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );

      });
  }
  DeletePrepopulation(id) {
    // this.spinner.show();
    const payload = {};

    payload['CgCode'] = id.CgCode;
    payload['CgName'] = id.CgName;
    payload['DsCode'] = id.DsCode;
    payload['TnCode'] = id.TnCode;
    payload['CgCent'] = id.CgCent;
    payload['CgOnlyCent'] = id.CgOnlyCent;
    payload['CgType'] = id.CgType;
    this.isReadonlyDelete = true;
    this.umsService.getCollege(payload).subscribe((res) => {
      // this.spinner.hide();
      const data = res.data[0];
      if (res.status) {
        let CgS1Cent = false;
        let CgOnlyCent = false;
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        if (data.CgS1Cent == 1) {
          CgS1Cent = true;
        } else {
          CgS1Cent = false;
        }
        if (data.CgOnlyCent == 1) {
          CgOnlyCent = true;
        } else {
          CgOnlyCent = false;
        }
        this.CollegeDataForm = this.fb.group({
          CgCode: new FormControl(data.CgCode, [
            Validators.required,
            Validators.pattern('^[a-zA-z0-9-&]*$'),
            Validators.maxLength(5),
          ]),
          CgShName: new FormControl(data.CgShName, [
            Validators.required
          ]),
          CgName: new FormControl(data.CgName, [
            Validators.required
          ]),
          CgAddr1: new FormControl(data.CgAddr1, [Validators.required]),
          CgAddr2: new FormControl(data.CgAddr2, [Validators.required]),
          CgAddr3: new FormControl(data.CgAddr3),
          CgPin: new FormControl(data.CgPin, [Validators.required, Validators.pattern('^[1-9]{1}?[0-9]*$'), Validators.maxLength(6), Validators.minLength(6)]),
          CgTnCode: new FormControl(data.TnCode),
          DsCode: new FormControl(data.DsCode, Validators.required), //add dummy
          CgLoca: new FormControl('',),
          CgS1Cent: new FormControl(CgS1Cent),
          CgS2Cent: new FormControl('',),
          CgS1Capa: new FormControl(''),
          CgS2Capa: new FormControl(''),
          CgOnlyCent: new FormControl(CgOnlyCent),
          CgType: new FormControl(data.CgType),
          // kle removed 
          CgEmail: new FormControl(data.CgEmail, [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), Validators.maxLength(50)]),
          CgWeb: new FormControl(data.CgWeb, [Validators.pattern("^(?!-)[a-zA-Z0-9-]{1,63}(?<!-)(\.[a-zA-Z]{2,})+$"), Validators.maxLength(50)]),
          CgPhone: new FormControl(data.CgPhone, [Validators.required, Validators.pattern('^[0-9-+ &\\s]*$'), Validators.minLength(10)]),
          CgFax: new FormControl(data.CgFax, [Validators.pattern('^[0-9-+ .&\\s]*$'), Validators.minLength(9)]),

        });
      } else {
        this.umsService.openSnackbar(res.message);
      }
    });
  }
  // Delete Record end
  // Fetch apis start 
 
  fetchDistrict() {
    const payload = {};
    this.umsService.getDistrict(payload).subscribe((res) => {
      if (res.status) {
        this.DsCodelist = res.data;
        this.filteredListDistCode = this.DsCodelist.slice();
      }
    });
  }
  fetchtype() {
    const payload = {};
    this.umsService.getCollegeType().subscribe((res) => {
      if (res.status) {
        this.typelist = res.data;
        this.filteredListTypeList = this.typelist.slice();
      }
    });
  }
  loadFormFieldConditions() {
    let payload = {};
    payload['FormPage'] = 'College';
    // payload['Inst'] = sessionStorage.getItem('Inst');
    this.dynamicrecords = [];
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.dynamicrecords = res.data;
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.CollegeDataForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.CollegeDataForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.CollegeDataForm.addControl(element.FormControlName, new FormControl(''));
          }
        }
      });
    });
  }
  // Fetch apis end


  onInputChange(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }
 
  capitalizeFirstLetter(event: any) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    let capitalizedValue = '';
    const words = input.value.split(' ');
    for (let i = 0; i < words.length; i++) {
        capitalizedValue += words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
        if (i < words.length - 1) {
            capitalizedValue += ' ';
        }
    }
    input.value = capitalizedValue;
    input.setSelectionRange(start, start);
}
}
